module.exports = __webpack_public_path__ + "assets/3-customer-success-manager-job-description.32a78afe.png";